
import React from 'react';
import PropTypes from 'prop-types';
import images from './images';
import './styles.css';


const BusinessPlanLayout = ({ children }) =>
	<div className="business-plan-layout">{children}</div>
	;
const SideBar = ({ children }) =>
	<div className="business-plan-layout-sidebar">{children}</div>
	;
const Body = ({ children }) =>
	<div className="business-plan-layout-body">{children}</div>
	;
const BodyHeader = ({ children, location }) => {
	const currentRoute = location.pathname.substr(
		location.pathname.lastIndexOf('/') + 1
	);
	let background;
	switch (currentRoute) {
	case 'sales':
		background = 'apples';
		break;
	case 'production':
	case 'procurement':
		background = 'grapes';
		break;
	default:
		background = 'apple';
	}
	return (
		<div
			className="business-plan-layout-body-header"
			style={{ backgroundImage: `url(${images[background]})` }}
		>
			<div>{children}</div>
		</div>
	);
};

BusinessPlanLayout.propTypes = {
	children: PropTypes.node,
	location: PropTypes.object
};

const BodyContent = ({ children, location }) => {

	let currentRoute = location.pathname.substr(
		location.pathname.lastIndexOf('/') + 1
	);

	return (
		<div className={`business-plan-layout-body-content ${currentRoute}`}>{children}</div>
	)
}
	;
const BodyFooter = ({ children }) =>
	<div className="business-plan-layout-body-footer">{children}</div>
	;

Object.assign(BusinessPlanLayout, {
	SideBar,
	Body,
	BodyHeader,
	BodyContent,
	BodyFooter
});

BusinessPlanLayout.propTypes = {
	children: PropTypes.node
};

export default BusinessPlanLayout;
